import { Debug } from "@biz/Debug";
import { SST } from "@biz/definitions/SST";
import { AxleMeasureType, ISunSailData, PoleId, PoleIndex, SunSailType } from "@biz/definitions/SunSailDefinitions";
import { PoleLogic } from "@biz/items/sunSail/logic/PoleLogic";

export class AxleLogic {
  static getLogicalAxleLengthType(sunSail: ISunSailData): AxleMeasureType {
    if (SST.is(sunSail.sunSailType, SST.One))
      return "brutto";
    return "netto";
  }

  static calcAxleDistSum(sunSail: ISunSailData, fn: (sunSail: ISunSailData, poleIndex: PoleIndex) => number): number {
    const axleIndices = PoleLogic.getAxleIndices(sunSail.sunSailType);
    if (!axleIndices)
      return 0;
    return fn(sunSail, axleIndices.first) + fn(sunSail, axleIndices.second);
  }

  static hasAxle(sunSailType: SunSailType): boolean {
    return (
      sunSailType === SunSailType.SolidayA ||
      sunSailType === SunSailType.SolidayOne ||
      sunSailType === SunSailType.SolidayFlex ||
      sunSailType === SunSailType.SolidayX ||
      sunSailType === SunSailType.SolidayM ||
      sunSailType === SunSailType.SolidayC ||
      sunSailType === SunSailType.SolidayCS ||
      sunSailType === SunSailType.SolidayXS ||
      sunSailType === SunSailType.SolidayTwin
    );
  }

  static getAxleCountForPole(sunSailType: SunSailType, poleId: PoleId): number {
    const isAxlePole = PoleLogic.isAxle(sunSailType, poleId);
    if (!isAxlePole)
      return 0;
    if (sunSailType === SunSailType.SolidayTwin)
      return 2;
    return 1;
  }

  static getAxleBruttoToNettoDist(sunSail: ISunSailData, poleIndex: number): number {
    Debug.assert(PoleLogic.isAxle(sunSail.sunSailType, poleIndex), "Pole is not an axle pole!");
    switch (sunSail.sunSailType) {
      case SunSailType.SolidayOne: {
        return poleIndex === PoleIndex.A ? 0.072 : 0;
      }
      case SunSailType.SolidayFlex: { // todo: Soliday-Flex
        return 0.0;
      }
      case SunSailType.SolidayM: {
        if (sunSail.version === "2024")
          return 0.03;
        return 0.0;
      }
    }
    return 0.0;
  }

  static showAxleLengthType(sunSail: ISunSailData, axleMeasureType: AxleMeasureType): boolean {
    if (AxleLogic.getLogicalAxleLengthType(sunSail) === axleMeasureType)
      return true;

    const dists = AxleLogic.calcAxleDistSum(sunSail, AxleLogic.getAxleBruttoToNettoDist);
    return dists > 0;
  }
}